import { CloseOutlined } from "@ant-design/icons";
import { Button, Space, message, Popconfirm, Table, Checkbox } from "antd";
import { useState } from "react";
import { serverFetch } from "../../server";
import SelectClient from "../../controls/select-client/select-client";
import { isMobile } from "@/extensions/design";


const StockOrder = ({ onClose }) => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSave = () => {
    setLoading(true);
    const ask = { supplierIds: items.map(item => item.id) };
    serverFetch("store/SupplierOrder", { method: "POST", bodyData: ask })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  // Добавление клиента в список
  const onAddClient = () => {
    if (selectedClient) {
      // Проверяем, что клиент еще не добавлен
      if (!items.find(item => item.id === selectedClient.value)) {
        setItems([...items, {
          id: selectedClient.value,
          name: selectedClient.label
        }]);
        setSelectedClient(null);
        message.success("Клиент добавлен");
      } else {
        message.warning("Клиент уже добавлен в список");
      }
    } else {
      message.warning("Выберите клиента");
    }
  }

  // Множественное удаление
  const onDeleteSelected = () => {
    if (selectedRowKeys.length > 0) {
      setItems(items.filter(item => !selectedRowKeys.includes(item.id)));
      setSelectedRowKeys([]);
      message.success(`Удалено ${selectedRowKeys.length} клиентов`);
    } else {
      message.warning("Выберите клиентов для удаления");
    }
  }

  const columns = [
    { dataIndex: "id", title: "#" },
    { dataIndex: "name", title: "Наименование" },
  ];

  return !isMobile ? (<div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className="sport-modal-content" style={{display: "flex", flexDirection: "column", rowGap: "8px"}} onMouseDown={e => e.stopPropagation()}>
        <div className="sport-modal-title">
          <span>Заказ поставщику</span>
          <CloseOutlined
            className="sport-section-title-close" 
            onClick={() => onClose(false)} style={{ zIndex: 9, color: "#2f6f00", fontSize: 16 }}                
          />
        </div>
        <Space>
          <SelectClient
            placeholder="Выберите клиента"
            value={selectedClient?.value}
            onChange={setSelectedClient}
            onClear={() => setSelectedClient(null)}
          />
          <Button onClick={onAddClient} disabled={!selectedClient}>Добавить</Button>
          <Button onClick={onDeleteSelected} disabled={selectedRowKeys.length === 0}>
            Удалить ({selectedRowKeys.length})
          </Button>
        </Space>
        <Table
          dataSource={items}
          pagination={false}
          columns={columns}
          size="small"
          loading={loading}
          rowKey="id"
          locale={{ emptyText: "Клиенты не выбраны" }}
          rowSelection={{
            type: 'checkbox',
            selectedRowKeys,
            onChange: setSelectedRowKeys,
            getCheckboxProps: (record) => ({
              name: record.name,
            }),
          }}
        />
        <Space>
          <Popconfirm title="Сформировать заказы поставщикам?" onConfirm={onSave} disabled={loading}>
            <Button disabled={loading}>Сформировать</Button>
          </Popconfirm>
          <Button onClick={() => onClose(false)} disabled={loading}>Отмена</Button>
        </Space>
      </div>
    </div>
  </div>) : (
  <div className="sport-modal">
    <div className="sport-modal-overlay">
      <div className="sport-modal-content">
        <div className="sport-modal-title">
          <span>Заказ поставщику</span>
          <CloseOutlined
            className="sport-section-title-close client-close-outlined-button-style" onClick={() => onClose(false)}             
          />
        </div>
        <div className="stock-osv-item-line-long-and-short ">
          <SelectClient placeholder="Выберите клиента" value={selectedClient?.value} onChange={setSelectedClient} 
          onClear={() => setSelectedClient(null)} className="records-client-product-select-mobile" style={{ maxWidth: 'calc(278px + (100vw - 405px))' }}/>
          <div style={{display: "flex", marginLeft: "auto"}}> 
            <Button style={{marginLeft: "6px", marginRight: "6px"}} onClick={onAddClient} disabled={!selectedClient}>+</Button>
            <Button style={{justifyContent: "flex-end"}} onClick={onDeleteSelected} disabled={selectedRowKeys.length === 0}> - ({selectedRowKeys.length})
          </Button>
          </div>
        </div>
        
        {items.length === 0 && !loading && (
          <div style={{ padding: 8 }}> Клиенты не выбраны </div>
        )}

        {items.map((item) => {
          const checked = selectedRowKeys.includes(item.id);
          return (
            <div key={item.id} className="client-item-sale" style={{ backgroundColor: checked ? "#eff2ee" : "#fafafa", display: "flex", alignItems: "flex-start", gap: 8, marginTop: "4px" }}>
              <Checkbox type="checkbox" checked={checked}
                onChange={(e) => {
                  if (e.target.checked) { setSelectedRowKeys([...selectedRowKeys, item.id]);} else {
                    setSelectedRowKeys(selectedRowKeys.filter((key) => key !== item.id));
                  }}}/>
              <div style={{ display: "grid", rowGap: "4px", flex: 1 }}>
                <div className="stock-osv-item-line-long-and-short" style={{ gridTemplateColumns: "1fr 50px"}}>
                  <div className="client-item-clip"> {item.name} </div>
                  <div className="client-item-clip-right"> #{item.id} </div>
                </div>
              </div>
            </div>
          );
        })}
        <div className="buttons-send-order">
          <Popconfirm  title="Сформировать заказы поставщикам?" onConfirm={onSave} disabled={loading}
            placement="top" getPopupContainer={(trigger) => trigger.closest('.buttons-send-order')} overlayClassName="centered-popconfirm">
              <Button style={{width: "100%", marginTop: "4px"}} disabled={loading}>Сформировать</Button>
          </Popconfirm>
        </div>
      </div>
    </div>
  </div>)
}

export default StockOrder;